<template>
  <div>
    <page-main
      :tableData="tableData"
      :waybillCode="waybillCode"
      :weightDisable="weightDisable"
      @openEditFormDialog="openEditFormDialog"
      @reload="reload"
    >
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      append-to-body
      show-close
      visible
      top="10vh"
      width="1000px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :waybillWeightCode="editFormDialogOptions.code"
        :waybillCode="waybillCode"
        :totPriceWeight="totPriceWeight"
        :transportMode="transportMode"
        @close="closeEditFormDialog"
        @reload="reload"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMain from './main'
import EditForm from './edit-form'
export default {
  components: {
    PageMain,
    EditForm,
  },
  props: {
    tableData: { type: Array, default: () => [] },
    weightDisable: { type: Boolean, default: false },
    waybillCode: { type: String, default: '' },
    totPriceWeight: { type: String, default: '' },
    transportMode: { type: String, default: '' },
  },
  data() {
    return {
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: '编辑',
        add: '新增',
        detail: '详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    reload() {
      this.$emit('reload')
    },
  },
}
</script>
